import React, { useEffect, useState } from 'react';
import { Row } from 'react-bootstrap';
import Instructor from '../Instructor/Instructor';

const Instructors = () => {
    // defining states
    const [instructors, setInstructors] = useState([]);
    useEffect(() => {
        // fetching data from API
        fetch('./instructors.JSON')
            .then(res => res.json())
            .then(data => setInstructors(data))
    }, [])
    return (
        <div>
            {/*Adding page title*/}
            <h1 className="fs-1 mb-4 mt-n2">Hundreds of Top Certified Instructors</h1>
            <p className="mb-5 fs-5 text-secondary">Our teachers are friendly, professional, and experienced.</p>
            {/*Shoeing Instructors*/}
            <Row xs={1} md={3} className="w-75 g-5 mx-auto mb-5 ">
                {
                    instructors.map(instructor => <Instructor
                        key={instructor.id}
                        instructor={instructor}
                    ></Instructor>)
                }
            </Row>
        </div>
    );
};

export default Instructors;